import React, { useState } from "react";
import Navbar from "../Components/Navbar";
import Sidebar from "../Components/Sidebar";
import useWindowDimensions from "../Hooks/useWindowDimensions";

import { Outlet } from "react-router-dom";
import IncomingCall from "../Components/IncomingCall";

export default function PrivatePageLayout(props) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { width } = useWindowDimensions();
  const isMobile = width <= 768;
  
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  
  const closeSidebar = () => {
    setSidebarOpen(false);
  };
  
  return (
    <div className="w-full h-screen flex flex-col">
      <Navbar onToggleSidebar={toggleSidebar} />
      <div className="flex h-full">
        <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />
        <Outlet />
      </div>
      <IncomingCall />
    </div>
  );
}
